import { Divider, Box, Image, Typography } from "@jewlr/storybook/core"
import styled from "styled-components"

export const PlanTitle = styled(Typography).attrs((props) => ({
  mb: "8px",
  ...props.theme.info.planTitle,
}))`
  font-size: 32px;
  font-weight: 700;
  line-height: 36.77px;
  white-space: nowrap;
`

export const PlanImage = styled(Image).attrs({
  height: { _: "auto", desktop: "121px" },
  mb: 1,
  width: { _: "auto", desktop: "305px" },
})``

export const PlanDesc = styled(Typography).attrs((props) => ({
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "20px",
  mb: 3,
  mx: "auto",
  width: { desktop: "312px" },
  ...props,
}))``

export const PlanSubtitle = styled(Typography).attrs((props) => ({
  mb: "12px",
  ...props,
}))`
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
`

export const PlanDivider = styled(Divider).attrs((props) => ({
  bg: "#D9D9D9",
  mb: 3,
  ...props,
}))``

export const PlanGirlImage = styled(Image).attrs({
  maxHeight: "216px",
  maxWidth: "224px",
  mb: { _: "20px", desktop: 3 },
})``

export const PlanProductImage = styled(Image).attrs({
  mb: "13px",
  width: { desktop: "216px" },
})``

export const Container = styled(Box).attrs((props) => ({
  flex: { desktop: 1 },
  mx: 2,
  px: 3,
  py: 4,
  width: { desktop: "50%" },
  ...props.theme.info.paymentPlanContainer,
  ...props,
}))`
  border: 1px solid #d9d9d9;

  ${(props) => props.theme.mediaQueries.desktop`
    border: none;
    margin: 0;
    :first-child{
          border-right: 1px solid #D9D9D9;
    }
  `}
`
export const LegalCopy = styled(Typography)`
  font-size: 12px;
  font-weight: 300;
  line-height: 14px;
  a {
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
`
